<template>
  <div class="app_container">
    <div class="header">
      <div class="header-top">
        <butn
          size="mini"
          class="btn"
          btntype="primary"
          iconName="el-icon-arrow-left"
          title="返回"
          @click="goBack"
        ></butn>
        <p>{{className}}</p>
        <div class="right"></div>
      </div>
      <div class="operate_rect">
        <butn class="btn" title="导出" @click="exportPage"></butn>
        <div class="header-bottom">
          <butn class="btn" size="mini" title="回到本周" @click="currentWeek"></butn>
          <butn class="btn" size="mini" title="上一周" @click="preWeek"></butn>
          <butn class="btn" size="mini" title="下一周" @click="nextWeek"></butn>
          <div class="bottom-picker">
            <el-date-picker
              class="datePicker"
              size="mini"
              v-model="monthValue"
              :editable="false"
              :clearable="false"
              type="month"
              :align="'center'"
              placeholder="选择月"
              prefix-icon="icon"
              @change="onChangeDatePicker"
            >
            </el-date-picker>
            <p @click="clickDatePick">{{ monthValue }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="table-content">
      <div class="table-header">
        <span class="table-top-left text3">午别</span>
        <div
          v-for="(item, index) in weekList"
          class="table-week-content"
          :key="index"
          :class="index > 4 ? 'week' : ''"
        >
          <div class="table-week-item">
            <div class="table-week-top">
              <p class="text3">{{ item.week }}</p>
              <p v-if="item.isToday" class="today">今</p>
            </div>
            <div class="table-week-bottom text">
              {{ item.date ? formatDate(item.date, 'dd号') : '' }}
            </div>
          </div>
        </div>
      </div>
      <div class="table-main">
        <div class="table-line" v-for="(line, index) in dataList" :key="line.type">
          <div class="table-item-center table-class-left"
               :class="index === dataList.length - 1 ? 'bottomBorder' : ''">
            <span class="text">{{ line.type }}</span>
          </div>
          <div class="class-item-content">
            <div
              class="table-class"
              v-for="(item, index) in line.list"
              :key="index"
            >
              <div
                class="table-item-start class-item"
                v-for="(classItem, itemIndex) in item"
                :key="itemIndex"
                :class="itemIndex === 0 ? 'clearTopBorder' : ''"
              >
                <span class="class-time text2">{{`${formatDate(classItem.teachingStartTime, 'hh:mm')} 至 ${formatDate(classItem.teachingEndTime, 'hh:mm')}`}}</span>
                <span class="class-type">{{ classItem.teachingForm }}</span>
                <span class="class-name text2" >{{ classItem.courseName }}</span>
                <span class="class-teacher text2">{{ classItem.teacherName }}</span>
                <span class="class-address text2">
                  <div class="blue_style" v-if="classItem.roomType == 2" @click="showRoomDetail(classItem)">{{classItem.teachingLocation}}</div>
                  <span v-else>{{classItem.teachingLocation}}</span>
                </span>
                <span class="class-students text2" v-if="classItem.groupNames">{{ classItem.groupNames !== "—" ? classItem.groupNames : "暂无分组" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 自习室组详情 -->
    <RoomGroup
      v-if="newDialogInfo.show"
      :classId="classId"
      :dialogInfo="newDialogInfo"
      @close="closeRoomDialog"
    />
  </div>
</template>

<script>
import butn from "@/components/button/index";
import { getCourseSchedule } from "@/api/class";
import { dateStrFormatToString } from "@/utils/timeFormat"
import { exportClassCourse } from "@/api/class";
import { ioRead } from "@/utils/common.js";
import RoomGroup from "@/views/offlineClass/roomManage/components/roomGroupDialog.vue";
export default {
  components: {
    butn,
    RoomGroup
  },
  data() {
    return {
      weekList: [
        { week: "周一", date: "" },
        { week: "周二", date: "" },
        { week: "周三", date: "" },
        { week: "周四", date: "" },
        { week: "周五", date: "" },
        { week: "周六", date: "" },
        { week: "周日", date: "" },
      ],
      dataList: [
        { type: "上午", list: [[], [], [], [], [], [], []] },
        { type: "下午", list: [[], [], [], [], [], [], []] },
        { type: "晚上", list: [[], [], [], [], [], [], []] },
      ],
      weekYear: "",
      weekOfYear: 1,
      monthValue: null,
      classId : null,
      classChildId: null,
      className: '',
      newDialogInfo: { show: false },
    };
  },
  created() {
    // this.isAttachment = this.$route.query.isAttachment;
    this.$nextTick(() => {});
    this.classId = this.$route.query.id;
    this.classChildId = this.$route.query.childId;
    this.getCurrentMonth();
    this.getCourseData();

  },
  methods: {
    // 自习室组详情
    showRoomDetail(item) {
      this.newDialogInfo = {
        show: true,
        type: 2,
        uuid: item.roomId,
      };
    },
    // 关闭自习室组详情
    closeRoomDialog() {
      this.newDialogInfo.show = false;
    },
    // 课程表导出
    exportPage() {
      exportClassCourse({
        classId: this.classId,
      }).then((response) => ioRead(response));
    },
    goBack() {
      if (this.classChildId) {
        this.$router.push({
          path: "/dataTraining/smallClassData",
          query: { classId: this.classId }});
      } else {
        this.$router.push('/dataTraining');
      }
    },
    getCourseData(month, year, weekOfYear) {
      let params = {
        classId: this.classId,
        month,
        year,
        weekOfYear,
      };
      if (this.classChildId) {
        params.classChildId = this.classChildId;
      }
      getCourseSchedule(params).then((res) => {
        if (res.code === 0 && res.data) {
          this.weekOfYear = res.data.weekOfYear;
          let year = res.data.year;
          this.weekYear = res.data.weekYear;
          let month = res.data.month;
          this.monthValue = `${year}年${month}月`
          this.className = res.data.className
          this.getDataList(res.data);
        }
      });
    },
    getDataList(data) {
      let noonList = [];
      let afternoonList = [];
      let eveningList = [];
      data.weekdays.forEach((item, index) => {
        this.weekList[index].date = item.date;
        this.weekList[index].isToday = item.isToday;
        noonList.push(item.noon);
        afternoonList.push(item.afternoon);
        eveningList.push(item.evening);
      });
      this.dataList = [];
      this.dataList.push({
        type: "上午",
        list: noonList,
      });
      this.dataList.push({
        type: "下午",
        list: afternoonList,
      });
      this.dataList.push({
        type: "晚上",
        list: eveningList,
      });
    },

    clickDatePick() {
      document
        .querySelector(".datePicker")
        .querySelector("input")
        .focus();
    },
    currentWeek() {
        this.getCourseData();
     },
    preWeek() {
        let weekIndex = this.weekOfYear - 1;
        this.getCourseData('', this.weekYear, weekIndex);
    },
    nextWeek() {
        let weekIndex = this.weekOfYear + 1;
        this.getCourseData('', this.weekYear, weekIndex);
    },

    onChangeDatePicker(e) {
        let date = e;
        let year = date .getFullYear(); 
        let month = date .getMonth() + 1; 
        this.weekYear = year;
        this.monthValue = `${year}年${month}月`
        this.getCourseData(month, year);
    },

    getCurrentMonth() {
        let date = new Date();
        let year = date .getFullYear(); 
        let month = date .getMonth() + 1; 
        this.weekYear = year;
        this.monthValue =   `${year}年${month}月`
    },

    formatDate(val, formater) {
       return dateStrFormatToString(val, formater);
    }

  },
  computed: {
    // userIds() {
    //   return this.checkArray.map(item => item.uuid);
    // }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.blue_style {
  color: #3A85FF;
  cursor: pointer;
}
.operate_rect {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header {
  .header-top {
    display: flex;
    justify-content: space-between;
    .btn {
      height: 30px !important;
    }
    p {
      flex: 1;
      text-align: center;
      color: #343C4A;
      font-size: 22px;
      margin: 0;
      font-weight: 500;
      
    }
    .right {
      width: 60px;
    }
  }
  .header-bottom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 10px;

    .bottom-picker {
      position: relative; 
      width: 100px;
      height: 22px;
      overflow: hidden;
      .datePicker {
          width: 100px;
          height: 22px;
          background: red;
        .icon {
          width: 0px;
          height: 0px;
        }
        /deep/ el-inpuit {
            text-align: center;
        }
        /deep/ el-input__inner {
          border: 0px;
        }
      }
      p {
          position: absolute;
          top: 0;
          left: 0;
          width: 100px;
          height: 22px;
          line-height: 22px;
          text-align: center;
          background: #ffffff;
          margin: 0;
        font-size: 12px;
        font-weight: 600;
        color: #343C4A;
        cursor: pointer;
      }
    }
  }
}
.table-content {
  margin-top: 20px;
  margin-bottom: 50px;
  width: 100%;
  border-top: 1px solid #CDD3D9;
  border-left: 1px solid #CDD3D9;
  .table-header {
    display: flex;
    .table-top-left {
      width: 60px;
      border-right: 1px solid #CDD3D9;
      background: #4983F5;
      text-align: center;
      line-height: 100px;
    }
    .table-week-content {
      flex: 7;
      .table-week-item {
        flex: 1;
        border-right: 1px solid #CDD3D9;
        .table-week-top {
          display: flex;
          border-bottom: 1px solid #CDD3D9;
          background: #4983F5;
          height: 50px;
          justify-content: center;
          align-items: center;
          .today {
            margin-left: 8px;
            width: 20px;
            height: 20px;
            background: #F5A24A;
            border-radius: 15px;
            color: #ffffff;
            font-weight: 500;
            font-size: 13px;
            text-align: center;
            line-height: 20px;
          }
        }
        .table-week-bottom {
          height: 50px;
          line-height: 50px;
          text-align: center;
          border-bottom: 1px solid #CDD3D9;
          background: #DCE7FA;
        }
      }
    }
  }
  .table-main {
    .table-line {
      display: flex;
      .table-class-left {
        width: 60px;
        border-top: 1px solid #CDD3D9;
        border-right: 1px solid #CDD3D9;
        min-height: 160px;
        background: #DCE7FA;
      }
      .class-item-content {
        display: flex;
        
        flex: 7;
        .table-class {
          flex: 1;
          width: 14.285%;
          display: flex;
          flex-direction: column;
          border-right: 1px solid #CDD3D9;
          border-bottom: 1px solid #CDD3D9;
          .class-item {
            width: '100%';
            border-top: 1px solid #CDD3D9;
            flex-direction: column;
            padding: 20px ;
            .class-time {  
              color: #53637E;
              line-height: 22px;
              font-size: 12px;          
            }
            .class-type {
                color: #283752;
                font-size: 12px;
                line-height: 22px;
                margin-top: 6px;
                font-weight: 500;
            }
            .class-name {
                margin-top: 8px;
                color: #343C4A;
                font-weight: 500;
                line-height: 16px;
                font-size: 12px;
                
            }
            .class-teacher {
                margin-top: 22px;
                line-height: 22px;
                color:#53637E;
                font-size: 12px;
            }
            .class-address {
                line-height: 22px;
                color:#53637E;
                font-size: 12px;
            }
            .class-students {
              display: inline-block;
              padding: 4px 10px;
              text-align: center;
              color: #ffffff !important;
              background: #3A85FF;
              border-radius: 15px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}

.table-item-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.table-item-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.text {
  font-size: 14px;
  color: #283752;
  margin: 0px;
  font-weight: 500;
  word-wrap: break-word;
  word-break: break-all;
  
}
.text1 {
  font-size: 14px;
  color: red;
  margin: 0;
}
.text2 {
    font-size:12px;
   color: #000000;
   word-wrap: break-word;
   word-break: break-all;
}
.text3 {
  font-size: 14px;
  color: #ffffff;
  margin: 0px;
  font-weight: 500;
}

.clearTopBorder {
  border-top: 0px solid #ffffff !important;
}
.topBorder {
  border-top: 1px solid #CDD3D9;
}
.bottomBorder {
    border-bottom: 1px solid #CDD3D9;
}
.week{
  opacity: 0.6;
}

</style>
